import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as componentTypes from "../constants/componentTypes";
import * as config from "../constants/config";
import * as filtering from "../constants/filtering";
import * as handlers from "../constants/handlers";
import * as methods from "../constants/methods";
import * as rcc from "../constants/rcc";
import * as getActions from "../actions/getActions";
import * as filteringHelper from "../helpers/filteringHelper";

const filteringInit = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.FILTERING_INIT),
        switchMap((action) => {
            return [
                getActions.getProducts(
                    action.payload.tabId,
                    false,
                    state$.value.settings.fts,
                    true,
                    true,
                    handlers.FILTERING_GET_DEFAULT_PRODUCT_LIST
                ),
                getActions.getFandecks(
                    action.payload.tabId,
                    false,
                    state$.value.settings.fts,
                    false,
                    true,
                    handlers.FILTERING_GET_DEFAULT_FANDECK_LIST
                ),
                getActions.getColors(
                    action.payload.tabId,
                    false,
                    state$.value.settings.fts,
                    state$.value.settings.searchPanelOrderByDistance,
                    true,
                    handlers.FILTERING_GET_DEFAULT_FORMULA_LIST
                ),
                getActions.getColors(
                    action.payload.tabId,
                    false,
                    state$.value.settings.fts,
                    state$.value.settings.searchPanelOrderByDistance,
                    true,
                    handlers.FILTERING_GET_DEFAULT_FORMULA_CODE_LIST
                ),
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.FILTERING_GET_DEFAULT_CUSTOMER_LIST,
                    tabId: action.payload.tabId
                }
            ];
        })
    );

const filteringLists = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.FILTERING_SAVE_PARAMS),
        switchMap(({payload}) => {
            if (state$.value.filtering[payload.tabId] === undefined) {
                return [];
            }

            let filteringParams = filteringHelper.getFilteringParams(payload.tabId, state$.value);

            if (payload.tabId === componentTypes.PURGE_STATS_SUBMENU) {
                if (
                    state$.value.filtering[componentTypes.PURGE_STATS_SUBMENU].consumptionType ===
                    rcc.CONSUMPTION_TYPE_PURGE
                ) {
                    return [
                        {
                            type: actionTypes.RCC_REQUEST,
                            payload: {
                                type: methods.METHOD_MACHINE_GET_PURGE_STATS,
                                params: {
                                    startDate: filteringParams.dateFrom,
                                    endDate: filteringParams.dateTo
                                }
                            },
                            method: handlers.MACHINE_GET_PURGE_STATS,
                            tabId: 0,
                            safe: true
                        }
                    ];
                }

                if (
                    state$.value.filtering[componentTypes.PURGE_STATS_SUBMENU].consumptionType ===
                    rcc.CONSUMPTION_TYPE_DISPENSE
                ) {
                    return [
                        {
                            type: actionTypes.RCC_REQUEST,
                            payload: {
                                type: methods.METHOD_MACHINE_GET_DISPENSE_STATS,
                                params: {
                                    startDate: filteringParams.dateFrom,
                                    endDate: filteringParams.dateTo
                                }
                            },
                            method: handlers.MACHINE_GET_DISPENSE_STATS,
                            tabId: 0,
                            safe: true
                        }
                    ];
                }

                if (
                    state$.value.filtering[componentTypes.PURGE_STATS_SUBMENU].consumptionType ===
                    rcc.CONSUMPTION_TYPE_ALL
                ) {
                    return [
                        {
                            type: actionTypes.RCC_REQUEST,
                            payload: {
                                type: methods.METHOD_MACHINE_GET_ALL_STATS,
                                params: {
                                    startDate: filteringParams.dateFrom,
                                    endDate: filteringParams.dateTo
                                }
                            },
                            method: handlers.MACHINE_GET_ALL_STATS,
                            tabId: 0,
                            safe: true
                        }
                    ];
                }
            }

            if (payload.tabId === componentTypes.COLORANT_REFILL_HISTORY_SUBMENU) {
                if (filteringParams.dateFrom === null && filteringParams.dateFrom === null) {
                    return [
                        {
                            type: actionTypes.RCC_REQUEST,
                            payload: {
                                type: methods.METHOD_MACHINE_HISTORY_REFILLS,
                                params: {
                                    rowCount: config.MAX_COLORANT_LIMIT,
                                    offset: 0
                                }
                            },
                            method: handlers.MACHINE_HISTORY_REFILLS,
                            tabId: 0,
                            safe: true
                        }
                    ];
                }

                return [
                    {
                        type: actionTypes.RCC_REQUEST,
                        payload: {
                            type: methods.METHOD_MACHINE_HISTORY_REFILLS,
                            params: {
                                startDate: filteringParams.dateFrom,
                                endDate: filteringParams.dateTo,
                                rowCount: config.MAX_COLORANT_LIMIT,
                                offset: 0
                            }
                        },
                        method: handlers.MACHINE_HISTORY_REFILLS,
                        tabId: 0,
                        safe: true
                    }
                ];
            }

            let tab = state$.value.navigation.tabList.find((tab) => tab.id === payload.tabId);

            let filteringActions = [];

            switch (tab.type) {
                case componentTypes.STATISTICS_TAB:
                    filteringActions.push({
                        type: actionTypes.STATISTICS_LIST_UPDATE,
                        payload: {
                            tabId: payload.tabId
                        }
                    });
                    break;
                case componentTypes.MY_ORDERS_TAB:
                    filteringActions.push({
                        type: actionTypes.MY_ORDERS_LIST_UPDATE,
                        payload: {
                            tabId: payload.tabId
                        }
                    });
                    break;
                case componentTypes.TO_DISPENSE_TAB:
                    filteringActions.push({
                        type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                        payload: {
                            tabId: payload.tabId
                        }
                    });
                    break;
                default:
                    break;
            }

            switch (payload.paramType) {
                case filtering.PRODUCT:
                    if (payload.paramValue.length > 0) {
                        filteringActions.push({
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_GET_BASES_BY_PRODUCT,
                                params: {
                                    productId: payload.paramValue[0].id,
                                    customFormulaOnly: false
                                }
                            },
                            method: handlers.FILTERING_GET_DEFAULT_BASE_LIST,
                            tabId: payload.tabId
                        });
                    } else {
                        filteringActions.push({
                            type: actionTypes.FILTERING_SAVE_DEFAULT_BASE_LIST,
                            payload: {
                                tabId: payload.tabId,
                                baseList: []
                            }
                        });
                        filteringActions.push({
                            type: actionTypes.FILTERING_SAVE_DEFAULT_PACKAGE_LIST,
                            payload: {
                                tabId: payload.tabId,
                                packageList: []
                            }
                        });
                    }
                    break;
                case filtering.BASE:
                    if (
                        state$.value.filtering[payload.tabId].selectedProductList.length > 0 &&
                        payload.paramValue.length > 0
                    ) {
                        filteringActions.push({
                            type: actionTypes.SERVER_REQUEST,
                            payload: {
                                type: methods.METHOD_GET_PACKAGES_BY_PARAMS,
                                params: {
                                    productId: state$.value.filtering[payload.tabId].selectedProductList[0].id,
                                    baseId: payload.paramValue[0].id
                                }
                            },
                            method: handlers.FILTERING_GET_DEFAULT_PACKAGE_LIST,
                            tabId: payload.tabId
                        });
                    } else {
                        filteringActions.push({
                            type: actionTypes.FILTERING_SAVE_DEFAULT_PACKAGE_LIST,
                            payload: {
                                tabId: payload.tabId,
                                packageList: []
                            }
                        });
                    }
                    break;
                default:
                    break;
            }

            return filteringActions;
        })
    );

const customFiltering = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.FILTERING_SAVE_CUSTOM_PARAMS),
        switchMap(({payload}) => {
            if (state$.value.filtering[payload.tabId] === undefined) {
                return [];
            }

            let tab = state$.value.navigation.tabList.find((tab) => tab.id === payload.tabId);

            switch (tab.type) {
                case componentTypes.STATISTICS_TAB:
                    return [
                        {
                            type: actionTypes.STATISTICS_LIST_UPDATE,
                            payload: {
                                tabId: payload.tabId
                            }
                        }
                    ];
                case componentTypes.MY_ORDERS_TAB:
                    return [
                        {
                            type: actionTypes.MY_ORDERS_LIST_UPDATE,
                            payload: {
                                tabId: payload.tabId
                            }
                        }
                    ];
                case componentTypes.TO_DISPENSE_TAB:
                    return [
                        {
                            type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                            payload: {
                                tabId: payload.tabId
                            }
                        }
                    ];
                default:
                    return [];
            }
        })
    );

export default [filteringInit, filteringLists, customFiltering];
